export default "__VITE_PUBLIC_ASSET__eefd7819__"